import { render, staticRenderFns } from "./Email-template.vue?vue&type=template&id=1dd12d85"
import script from "./Email-template.vue?vue&type=script&lang=js"
export * from "./Email-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports